export const darkenColor = (hex, percent) => {
	// Convert hex to RGB
	let r = parseInt(hex.slice(1, 3), 16);
	let g = parseInt(hex.slice(3, 5), 16);
	let b = parseInt(hex.slice(5, 7), 16);

	// Calculate the adjustment factor
	const adjust = (value) => Math.max(0, Math.min(255, Math.floor(value * (1 - percent / 100))));

	// Apply adjustment
	r = adjust(r);
	g = adjust(g);
	b = adjust(b);

	// Convert RGB back to hex
	const toHex = (x) => x.toString(16).padStart(2, '0').toUpperCase();
	return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const getGMTOffset = (date) => {
	const offset = date.getTimezoneOffset();
	const absOffset = Math.abs(offset);
	const hours = Math.floor(absOffset / 60);
	const minutes = absOffset % 60;
	const sign = offset > 0 ? '-' : '+';

	return `GMT${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const convertToSlug = (text) => {
	return text
		.toString()
		.toLowerCase()
		.replace(/\s+/g, '-') // Replace spaces with hyphens
		.replace(/[^\w-]+/g, '') // Remove non-word characters
		.replace(/--+/g, '-') // Replace multiple hyphens with one
		.trim(); // Remove leading/trailing space
};

export const anyFilterEnabled = (...filters: boolean[]): boolean => {
	return filters.some(Boolean);
};
